export default "__VITE_PUBLIC_ASSET__2c30741d__"